import axios from 'axios';
import {
  API_GEOMAP_CONTRACTS_CREATE,
  API_GEOMAP_CONTRACTS_GET_USER,
  API_GEOMAP_CONTRACTS_GET_CONTRACT,
  API_GEOMAP_CONTRACTS_UPDATE,
  API_GEOMAP_CONTRACTS_DELETE_CONTRACT
} from '../../constants'

export default {
  state: {
    contracts: [],
    contract: [],
    validtimes: [],
    validtime: null,
    basetime: null,
    basetimes: [],
    territories: [],
    parameters: ['tp'],
  },
  mutations: {
    SET_GEOMAP_CONTRACTS: (state, payload) => {
      state.contracts = payload;
    },
    SET_GEOMAP_CONTRACT: (state, payload) => {
      state.contract = payload;
    },
    DELETE_GEOMAP_CONTRACT(state, payload) {
      const index = state.contracts.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.contracts.splice(index, 1);
      }
    },
  },
  actions: {
    CREATE_GEOMAP_CONTRACT: async (context, payload) => {
      try {
        const response = await axios.post(API_GEOMAP_CONTRACTS_CREATE(), payload);
        context.commit('SET_GEOMAP_CONTRACT', response.data.result);
        context.commit('PUSH_SUCCESS', 'Контракт успешно создан');

        return response.data.result;
      } catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', err);
        return null;
      }
    },
    FETCH_GEOMAP_USER_CONTRACTS: async (context, payload) => {
      try {
        const url = API_GEOMAP_CONTRACTS_GET_USER(payload.userId, payload.take, payload.skip);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_CONTRACTS', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_CONTRACT: async (context, payload) => {
      try {
        const url = API_GEOMAP_CONTRACTS_GET_CONTRACT(payload.userId, payload.contractId);
        let response = await axios.get(url);
        const data = response.data.result;
        context.commit('SET_GEOMAP_CONTRACT', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    UPDATE_GEOMAP_CONTRACT: async (context, payload) => {
      try {
        await axios.put(API_GEOMAP_CONTRACTS_UPDATE(), payload);
        context.commit('SET_GEOMAP_CONTRACT', payload);
        context.commit('PUSH_SUCCESS', 'Контракт успешно изменен');
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    DELETE_GEOMAP_CONTRACT: async (context, payload) => {
      try {
        await axios.delete(API_GEOMAP_CONTRACTS_DELETE_CONTRACT(payload.userId, payload.contractId));
        context.commit('DELETE_GEOMAP_CONTRACT', payload.id);
        context.commit('PUSH_SUCCESS', 'Контракт успешно удален');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return false;
      }
    },
  },
  getters: {
    GEOMAP_CONTRACT: state => {
      return state.contract;
    },
    GEOMAP_CONTRACTS: state => {
      return state.contracts;
    },
  }
}